export default {
  sidebar: {
    general: {
      title: 'General',
      short_title: 'Gen',
      home: 'Home',
      students: 'Students',
      teachers: 'Teachers',
    },
    courses: {
      title: 'Courses',
      short_title: 'Crs',
      courses: 'Courses',
      history: 'History',
      calendar: 'Calendar',
    },
    activities: {
      title: 'Activities',
      short_title: 'Act',
      homework: 'Homework',
      quiz: 'Quiz',
    },
    actions: {
      account_settings: 'Account Settings',
      logout: 'Logout',
    },
    agency_name_placeholder: 'Your institution',
  },
  auth: {
    agency_name: 'Tuition Center',
    login: 'Log in',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    loginbutton: 'Log in',
    logout: 'Log out',
    hasaccount: 'Do not have an account?',
    signup: 'Sign up',
    forgotpassword: 'Forgot password?',
    reset: 'Reset',
    alreadyhasaccount: 'Already have an account?',
    lastname: 'Last Name',
    firstname: 'First Name',
    firstname_student: 'Student First Name',
    createaccount: 'Create Account',
    passwordreset: 'Reset your password',
    passwordresetbutton: 'Reset Password',
    no_active_account: 'No active account found with the given credentials',
    signup_subtitle: 'Enter your credentials to create an account on Funclass.',
    email_enter: 'Enter your email',
    email_send: 'Send Email',
    agree_to: 'I agree to the',
    terms: 'Terms and Conditions',
    required: {
      agency_name: 'Tuition center name is required',
      email: 'Email is required',
      invalid_email: 'Email is invalid',
      password: 'Password is required',
      first_name: 'First name is required',
      last_name: 'Last name is required',
      password_length: 'Password needs to be at least 8 characters long',
      password_requirement:
        "Password must contain at least one uppercase and one lowercase letter, one digit, and one special character ({'@'} $ ! % * ? & #).",
      email_exists: 'Account with this email already exists',
    },
    verify_email: {
      title: 'Please verify your email ',
      send_email_to: 'You are almost there! We sent an email to ',
      click_to_signup:
        'Just click on the verification button to complete your signup.',
      check_spam:
        "If you don't see it, you may need to check your spam folder.",
      still_dont_see: "Still can't find the email? No problem!",
      button: 'Resend verification email ',
    },
    manage_subscription_dialog_text:
      'Please contact yan@getfunclass.com to manage or cancel your subscription. Thank you!',
  },
  button: {
    submit: 'Submit',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    copy: 'Copy!',
    archive: 'Archive',
    unarchive: 'Unarchive',
    invite: 'Invite',
  },
  course: {
    title: 'Class Dashboard',
    create: 'Add Class',
    class_name: 'Class name',
    class_name_placeholder: 'Enter your class name here',
    duration: 'Duration',
    duration_time_unit: 'minutes',
    edit: 'Edit Class',
    view: 'View Class',
    share: 'Share Class',
    start: 'Start Class',
    join: 'Join Class',
    shareText: 'Share the link to invite your students to join the class!',
    delete_message: 'Are you sure you want to delete this class?',
    delete_confirmation: 'Delete Confirmation',
    delete: 'delete',
    delete_student:
      'Are you sure you want to remove this student from the class?',
    progress: 'Progress',
    use_zoom: 'Use Zoom classroom',
    chinese_students: 'This class has students in China',
    name_too_short: 'Course name must be at least 2 characters long',
    subscription_expired: 'Subscription expired',
    please_resubscribe: 'Please resubscribe to Funclass to continue.',
    link_valid_for: 'This link is valid for {n} days',
    resubscribe: 'Resubscribe',
    not_paid: 'You have to pay first to join the class',
    no_content: {
      filtered: {
        title: 'No class here',
        subtitle: 'Try changing the filters.',
      },
      general: {
        title: 'No class created yet',
        teacher_subtitle: 'Click on the “Add class” button to get started!',
        teacher_subtitle_agency:
          'No courses assigned yet. Please wait for your academy to assign you a course.',
      },
    },
    class_settings: {
      title: 'Classroom Settings',
      recording_exclude_webcam: 'Recording doesn’t include students’ webcam',
      enable_breakout_room:
        'Enable breakout room (disables automatic audio join)',
      gamified: 'Gamified',
      non_gamified: 'Non-gamified',
      account_type: 'Account Type',
      account_type_warning_setup:
        'The gamification type can only be set once during class creation.',
      account_type_warning_non_gamified:
        "Students won't have a pet and won't collect any XP/ HP.",
    },
    filters: {
      active: 'Active classes',
      archived: 'Archived classes',
      all: 'All classes',
    },
    notify: {
      required_fields: 'Please fill in required fields',
      delete_course_error: 'Error deleting course',
      archive_course_error: 'Error archiving course',
      archive_course_success: '{courseName} class archived successfully!',
      unarchive_course_error: 'Error unarchiving course',
      unarchive_course_success: '{courseName} class unarchived successfully!',
      copy_link_success: 'Copied!',
      copy_link_error: 'Error copying link',
      start_meeting_error: 'Error starting the meeting. Please try again.',
      edit_course_error: 'Error editing course',
    },
  },
  profile: {
    title: 'My home',
    your_classes: 'Your Classes',
    avatar_messages: {
      pet_revived:
        'Thank you for working hard to find me back! I miss you! Now you can feed me 🙂',
      welcome_new:
        "Hi {name} 👋, nice to meet you! I'm your learning companion {petName}. Earn some XPs in the class to hatch me! 🐣",
      hungry: "I'm hungry 🥺. Earn some food from your class to feed me.",
      first_xp:
        'Wow! You earned {lastXP} XPs in your last lesson. {xpToNextLevel} XPs left from hatching me. I wonder how I would look like 🐣',
      level_up:
        'Wow! You earned {lastXP} XPs in your last lesson. {xpToNextLevel} XPs left to reach your next level. Keep going!',
      welcome_back:
        "Hi {name}, welcome back!👋 I'm ready to learn something new with you today! 📚✨",
      pet_gone_named: 'Unfortunately, {petName} is gone... 💔',
      pet_gone_generic: 'Unfortunately, your pet is gone... 💔',
      pet_revive_hint_named: 'Buy medicine from shop to revive {petName}.',
      pet_revive_hint_generic: 'Buy medicine from shop to revive your pet.',
    },
    avatar_actions: {
      my_items: 'My Items',
      shop: 'Shop',
      pet_guide: 'Pet Guide',
    },
    pet_letter: {
      received_title_named: 'You received a letter from {petName}',
      received_title_generic: 'You received a letter from your pet',
      open_button: 'Open',
      letter_title_named: "{petName}'s letter",
      letter_title_generic: "Your pet's letter",
      paragraph_1:
        'It was really nice getting to know you and being your learning companion. I had a great time learning with you. However, I’m feeling a bit ignored recently. 💔',
      paragraph_2:
        'So, I decided to leave for a while to look for a more caring environment. Gather 200 coins to buy a potion in the shop to find me back.',
      paragraph_3: 'I’m looking forward to seeing you again soon!',
      signature: 'Yours,\n{petName}',
    },
    coin_modal: {
      earned_coins: 'Wow! You earned {rewardAmount} FunCoins!',
      shop_button: 'Go to Shop',
    },
    level_up_modal: {
      submit_button: 'Submit',
    },
    revive_pet_modal: {
      title: 'Reward',
      revive_message_named:
        'You’ve gathered 100 HPs 🎉\nYou can revive {petName} now.',
      revive_message_generic:
        'You’ve gathered 100 HPs 🎉\nYou can revive your pet now.',
      revive_button: 'Revive',
    },
    feedback_modal: {
      title: 'Lesson feedback',
      submit_button: 'Submit feedback',
      description: 'Please rate your lesson experience below',
      no_rating: 'No rating',
      rating_format: '{rating}/5 stars',
      label: 'Why do you give this rating?',
      rules: {
        required: 'Feedback is required',
        max: 'Feedback must be less than 300 characters',
        min: 'Feedback must be more than 10 characters',
      },
      lesson_not_ended: 'Lesson not ended?',
    },
  },
  scheduling: {
    start_date: 'Start date',
    lesson_time: 'Lesson time',
    lesson_time_info:
      "Select your local time. We automatically adjust the time to the students' timezone.",
    end_date: 'End date',
    reminder: {
      label: 'Reminder for students',
      hours_before: '{n} hour before | {n} hours before',
    },
    recurrence: {
      label: 'Recurrence',
      none: 'None',
      daily: 'Daily',
      weekly: 'Weekly',
      biweekly: 'Every 2 weeks',
      custom: 'Custom',
      repeat_every: 'Repeat every',
      time_unit_day: 'day | days',
      time_unit_week: 'week | weeks',
      occurs_on: 'Occurs on',
    },
    edit: {
      title: 'Edit Scheduled Lesson',
      options: {
        title_edit: 'Select events to apply changes to',
        title_delete: 'Select events to delete',
        current: 'This lesson',
        future: 'This and future lessons',
      },
      error: 'An error occurred while updating the event',
    },
  },
  quiz: {
    title: 'Quiz Dashboard',
    name_not_empty: 'Quiz name cannot be empty',
    name_limit: 'The characters cannot exceed 50',
    create: 'Create Quiz',
    save: 'Save Quiz',
    create_name: 'Quiz Name',
    create_description: 'Quiz Description',
    edit_questions: 'Edit Questions',
    delete_confirmation: 'Delete Confirmation',
    delete_message: 'Are you sure you want to delete this quiz?',
    delete: 'delete',
    folder: {
      title: 'Quiz Dashboard',
      create: 'Create Folder',
      create_name: 'Folder Name',
      save: 'Save Folder',
      edit: 'Edit Folder',
      delete: 'Delete Folder',
      delete_confirmation: 'Delete Confirmation',
      delete_message:
        'Are you sure you want to delete this folder? This will delete all quizzes inside the folder.',
      name_not_empty: 'Folder name cannot be empty',
      name_limit: 'The characters cannot exceed 50',
    },
    edit: {
      add_question: 'Add Question',
      title: 'Edit Quiz',
      save_question: 'Save Questions',
      delete_question: 'Delete Question',
      delete_message: 'Are you sure you want to delete this question?',
      add_answer: 'Add Answer',
      add_alt_answer: 'Add Alternative Answer',
    },
  },
  inclassQuiz: {
    folderTitle: 'Select a Folder',
    title: 'Select a Quiz',
    modeTitle: 'Select a mode',
    dragMe: 'Drag me',
    noQuizYet1: 'No quiz here yet.',
    noQuizYet2: 'Please create one first outside of the class.',
    studentsJoinedCount: 'students have joined',
    teacherPreStartQuiz: 'You are about to start the quiz...',
    quizRuleDescription1:
      '• For each question students get right, the monster loses a life',
    quizRuleDescription2:
      '• For each question students get wrong, they lose a life',
    quizRuleDescription3:
      '•⁠ By the end of the quiz, students must have more lives than the monster to win the battle!',
    quizRuleDescriptionStudent1:
      '• For each question you get right, the monster loses a life',
    quizRuleDescriptionStudent2:
      '• For each question you get wrong, you lose a life',
    quizRuleDescriptionStudent3:
      '•⁠ By the end of the quiz, you must have more lives than the monster to win the battle!',
  },
  homework: {
    dashboard: {
      title: 'Homework Dashboard',
      create: 'Assign Homework',
      no_due_date: 'No due date',
      na: 'N/A',
      submit: 'Submit',
      due: 'Due',
      submission_not_required: 'No submission required',
      submitted_on: 'Submitted on',
      graded_on: 'Graded on',
      view_submission: 'View',
      delete_confirmation: 'Delete Confirmation',
      delete_message: 'Are you sure you want to delete this homework?',
      delete_button: 'Delete {assignment}',
      archived: 'Archived',
      tabs: {
        pending: 'Pending',
        completed: 'Completed',
        graded: 'Graded',
      },
      filters: {
        all_classes: 'All classes',
        any_status: 'Any status',
        assigned: 'Assigned',
        to_be_graded: 'To be graded',
        all_graded: 'All graded',
        no_submission_needed: 'No submission needed',
        archived: 'Archived',
      },
      num_submitted: '{submitted} / {total} submitted',
      no_content: {
        filtered: {
          title: 'No homework matches your filters',
          subtitle:
            "Try changing the filters to find the homework you're looking for.",
        },
        general: {
          title: 'No homework created yet',
          subtitle: 'Click on the “Assign homework” button to get started!',
        },
        pending: {
          title: 'No pending assignments',
          subtitle: 'Check back later for new assignments.',
        },
        completed: {
          title: 'No completed assignments',
          subtitle:
            'Your completed assignments waiting to be graded will appear here.',
        },
        graded: {
          title: 'No graded assignments',
          subtitle: 'Your graded assignments will appear here.',
        },
      },
      header: {
        title: 'Title',
        class: 'Class',
        due: 'Due',
        status: 'Status',
      },
      notify: {
        delete_assignment_success: 'Assignment deleted successfully!',
        delete_assignment_error:
          'Failed to delete assignment. Please try again later.',
        archive_assignment_success: 'Assignment archived successfully!',
        archive_assignment_error:
          'Failed to archive assignment. Please try again later.',
        unarchive_assignment_success: 'Assignment unarchived successfully!',
        unarchive_assignment_error:
          'Failed to unarchive assignment. Please try again later.',
      },
    },
    assign: {
      title: 'Assign Homework',
      assignment_info: {
        title: 'Title',
        title_required: 'Title is required',
        description: 'Homework description',
        submission_required: 'Submission required',
        due_date: 'Due date (your local time)',
        due_date_past: 'Due date must be in the future',
        attach_files: 'Attach files',
        class: 'Class',
        choose_class: 'Choose a class to assign to',
        attachments: 'Attachments',
      },
      create: 'Assign',
      upload_attachments: 'Upload your attachment(s)',
      remove_attachment: 'Remove',
      confirm_leave:
        'Are you sure you want to leave this page? Your changes will not be saved.',
    },
    details: {
      title: 'Homework',
      homework_details: 'Homework details',
      description: 'Description',
      due: 'Due',
      attachments: 'Attachments',
      download_attachment: 'Download',
      student_submissions: 'Student submissions',
      homework_submission: 'Homework submission',
      submitted_on: 'Submitted on',
      not_submitted: 'Not submitted',
      submission_not_required: 'No submission required',
      view_submission: 'View',
      your_submission: 'Your submission',
      submit_homework: 'Submit',
      attach_files: 'Attach files',
      post_submission_success: 'Submission sent successfully!',
      upload_attachments: 'Upload your attachment(s)',
      teacher_feedback: 'Teacher feedback',
      graded_on: 'Graded on',
      reward: 'Reward:',
      remove_attachment: 'Remove',
      edit_homework: 'Edit homework',
      edit_submission: 'Edit submission',
      delete_confirmation: 'Delete Confirmation',
      delete_message: 'Are you sure you want to delete this homework?',
      delete_button: 'Delete {assignment}',
    },
    submission_details: {
      title: 'Homework',
      submitted_on: 'Submitted on',
      description: 'Homework submission',
      attachments: 'Attachments',
      download_attachment: 'Download',
      attach_files: 'Attach files',
      your_feedback: 'Your feedback',
      teacher_feedback: 'Teacher feedback',
      send_feedback: 'Send',
      reward_xp: 'Reward XP',
      rewarding: 'Rewarding',
      reward_xp_placeholder: 'Enter the XP amount here',
      save_reward: 'Save',
      save_reward_success: 'Reward amount saved successfully!',
      send_feedback_success: 'Feedback sent successfully!',
      graded_on: 'Graded on',
      reward: 'Reward:',
      remove_attachment: 'Remove',
    },
    edit: {
      title: 'Edit homework',
      assignment_info: {
        title: 'Title',
        title_required: 'Title is required',
        description: 'Homework description',
        submission_required: 'Submission required',
        due_date: 'Due date (your local time)',
        due_date_past: 'Due date must be in the future',
        attach_files: 'Attach files',
        class: 'Class',
        choose_class: 'Choose a class to assign to',
        attachments: 'Attachments',
      },
      save_changes: 'Save changes',
      upload_attachments: 'Upload your attachment(s)',
      remove_attachment: 'Remove',
      keep_attachment: 'Keep',
      confirm_leave:
        'Are you sure you want to leave this page? Your changes will not be saved.',
    },
    edit_submission: {
      title: 'Edit submission',
      homework_details: 'Homework details',
      description: 'Description',
      due: 'Due',
      attachments: 'Attachments',
      download_attachment: 'Download',
      your_submission: 'Your submission',
      last_submitted_on: 'Last submission was made on',
      attach_files: 'Attach files',
      resubmit_homework: 'Resubmit',
      upload_attachments: 'Upload your attachment(s)',
      remove_attachment: 'Remove',
      keep_attachment: 'Keep',
      edit_submission_success: 'Submission edited successfully!',
    },
  },
  onboarding_zoom: {
    student: {
      welcome_title: 'Welcome to Funclass ',
      welcome_subtitle: "Let's get your class ready in 2 quick steps!",
      title_step_1: "Connect Zoom to Start Learning",
      description_step_1_1: "Funclass uses Zoom for live lessons. Join directly from Funclass—no more links needed!",
      description_step_1_2: "Earn rewards from your Zoom lessons as you learn and grow your avatar along the way!",
      connect_button: "Connect Zoom",
      skip_button: "Skip for now",
      watch_tutorial: "Watch Tutorial Video",
      tutorial_subtitle: "Learn how to use Funclass in just 1 minute",
      finish_onboarding_button: "Start learning",
      handbook_button: "Read handbook"
    },
    teacher: {
    },
  },
  onboarding: {
    course: {
      teacher: [
        {
          title: 'Welcome to Funclass 🎉!',
          header: [],
          body: [
            "At Funclass, teachers can reward students' learning efforts and progress with XPs (experience points) just like playing a game!",
          ],
          button_text: 'Next',
        },
        {
          title: '',
          header: [
            "Don't abuse the XPs unless students show real efforts and progress.",
            'With the XPs, students can...',
          ],
          body: [
            'show their learning process',
            'level up their magical pets',
            'unlock more surprises!',
          ],
          button_text: 'Next',
        },
        {
          title: 'You can reward students for...',
          header: [],
          body: [
            'Active class participation',
            'In-class quizzes',
            'Completion of assignments',
            'Good preparation for the class',
            'and other positive learning behaviours...',
          ],
          button_text: 'Next',
        },
        {
          title: '',
          button_text: '',
        },
        {
          title: '',
          header: [],
          body: [
            'Read the Funclass Handbook to find out tips and best practices.',
          ],
          button_text: '',
        },
      ],
      egg_unhatched:
        'Your pet is still unhatched. Earn XPs from your class to upgrade to __Level {level}__ to hatch your egg!',
      browser_notice: [
        {
          header: ['⚠️ Please Read: Supported Browsers'],
          body: [
            '',
            'For optimal performance and compatibility, please use one of the supported browsers below 🚀',
            '🔹 Desktop/Laptop: Chrome, Firefox, or Edge (latest version)',
            '🔹 Mobile (iOS 12.2+): Safari',
            '🔹 Mobile (Android 10.0+): Chrome',
            '',
          ],
          acknowledgement_text: 'I have read and understood.',
        },
      ],
    },
    navigation: {
      next: 'Next',
      finish: 'Finish',
      skip_now: 'Skip for now',
    },
  },
  understandingCheck: {
    start: 'You are about to launch the understanding check',
    teacher: 'How students are feeling right now',
    student: 'How are you feeling right now?',
    studentButtonYes1: 'Good! 😄',
    studentButtonYes2: 'I understood.',
    studentButtonNo1: 'Hmm🤔️',
    studentButtonNo2: 'A bit confused.',
  },
  inclass: {
    endLesson: 'Do you want to end the lesson?',
  },
  viewClass: {
    addStudent: 'Invite a student',
    addStudents: 'Add students',
    addMore: 'Add more students',
    email: 'Email address',
    enterEmail: 'Enter student email here',
    invite: 'Invite',
    notEmpty: 'Field cannot be empty',
    notValid: 'Email is not valid',
    tabs: {
      student_list: 'Student list',
      course_material: 'In-class slides',
      lesson_history: 'Lesson history',
    },
    student_name: 'Student name',
    xps_earned: 'XPs earned',
    attendance: 'Attendance',
    absence: 'Absence',
    lesson: 'Lesson',
    date: 'Date',
    recording_button: 'Recording',
    feedback_button: 'Feedback',
    download_recording: 'Download recording',
  },
  recording: {
    delete_confirmation: 'Are you sure you want to delete this recording?',
  },
  meeting: {
    button_join_quiz: 'Join active quiz',
    attention_tracker_disable: 'Disable attention tracker',
    attention_tracker_enable: 'Enable attention tracker',
  },
  account: {
    title: 'Account Settings',
    subtitle: 'You can manage your account settings here',
    profile: 'Profile',
    plan_usage: 'Plan & Usage',
    policy: 'Policy',
    reschedule: 'Reschedule',
    policy_subtitle:
      'Set how many hours in advance a rescheduling request can be made for lessons.',
    policy_setting_before: 'hours before',
    policy_setting_cancel: 'Cancellation',
    policy_setting_cancel_subtitle:
      'Set how many hours in advance a cancellation request can be made for lessons.',
    change_photo: 'Change photo',
    first_name_capitalized: 'FIRST NAME',
    last_name_capitalized: 'LAST NAME',
    academy_capitalized: 'ACADEMY',
    email_capitalized: 'EMAIL',
    subscription: 'Subscription',
    subscription_info_contact:
      "{'Please contact yan@getfunclass.com to manage or cancel your subscription. Thank you!'}",
    currency: 'Currency',
    currency_description:
      'Currency for student tuition fees and teacher payroll.',
    personal_information: 'Personal Information',
    payment_setup: 'Payment Setup',
    stripe_details: 'Stripe Details',
    stripe: 'Stripe',
    stripe_description: 'Enable Stripe for Funclass to receive payments.',
    setup_stripe: 'Setup Stripe',
    complete_current_setup: 'Complete current setup',
    create_stripe_account: 'Create Stripe account',
    stripe_link: 'Please follow the link to configure your Stripe account.',
    split_payment: 'Split Payment',
    edit_stripe_details: 'Edit Stripe details',
    billing_cycle_period: 'Billing Cycle Period (for teacher payroll only)',
    language_settings: 'Language Settings',
    language: 'Language',
    meeting_settings: 'Meeting Settings',
  },
  upload: {
    photo_upload: 'Upload your image',
    agency_logo_upload: "Upload your institution's logo",
    square_image: 'Square image recommended.',
    upload_file_type: 'Only {formats} formats accepted.',
    pick_file: 'Pick a file',
    drag_and_drop: 'or drag and drop',
    upload_file: 'Upload file',
    upload: 'Upload',
  },
  notifications: {
    title: 'Notifications',
    empty: 'No notifications',
    messages: {
      ENROLLMENT_STUDENT: '{name} has enrolled to {description}',
      ASSIGNMENT_CREATED: '{name} has created homework {description}',
      ASSIGNMENT_SUBMITTED: '{name} has submitted a homework for {description}',
      ASSIGNMENT_GRADED: '{name} has graded homework {description}',
      LESSON_REVIEWED: '{name} has rated your {description}',
      STUDENT_REVIEWED: '{name} has given you feedback for class {description}',
      ENROLLMENT_STUDENT_AGENCY: '{name} has registered to {description}',
      ENROLLMENT_TEACHER_AGENCY: '{name} has enrolled in your agency',
      LESSON_RESCHEDULE_REQUESTED:
        '{name} has requested to reschedule a lesson for {description}',
      LESSON_CANCEL_REQUESTED:
        '{name} has requested to cancel a lesson for {description}',
      LESSON_RESCHEDULED: '{name} has rescheduled a lesson for {description}',
      LESSON_CANCELLED: '{name} has cancelled a lesson for {description}',
    },
  },
  datetime: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      short: {
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
        sunday: 'Sun',
      },
      initials: {
        monday: 'M',
        tuesday: 'T',
        wednesday: 'W',
        thursday: 'T',
        friday: 'F',
        saturday: 'S',
        sunday: 'S',
      },
    },
    time_format: 'at {time}',
  },
  my_calendar: {
    title: "My Calendar",
    subtitle: "You can view and manage all your lessons and availability here.",
    today: "Today",
    month: "Month",
    week: "Week",
    day: "Day",
    previous: "Previous",
    next: "Next",
    reschedule_requests: "Reschedule Requests",
    from_admin: "From Admin",
    your_requests: "Your requests",
    cancel_lesson: "Cancel lesson",
    course: "Course",
    from: "from",
    to: "to",
    notes: "Notes",
    date_time: "Date & Time",
    date: "Date",
    reschedule_note: "Reschedule Note",
    attendees: "Attendees",
    teachers: "Teachers",
    students: "Students",
    all_members: "All members",
    cancel: "Cancel",
    send_request: "Send request",
    save: "Save",
    view_lesson: "View Lesson",
    join: "Join",
    reschedule: "Reschedule",
    reschedule_constraint: "The rescheduling request should be raised at least {hours} hrs before",
    cancellation_constraint: "All cancellations must be done at least {hours} hrs before",
    cancel_lesson_title: "Cancel Lesson",
    reschedule_lesson_title: "Reschedule Lesson",
    accept_request: "Accept Request",
    suggest_alternative_title: "Suggest Alternative",
    confirm_approve_reschedule: "Are you sure you want to approve this reschedule request?",
    abort: "Abort",
    confirm: "Confirm",
    notify: {
      request_cancel_success: 'Lesson cancellation request submitted successfully.',
      request_cancel_error: 'Failed to submit lesson cancellation request. Please try again.',
      approve_reschedule_request_success: 'Reschedule request approved successfully.',
      approve_reschedule_request_error: 'Failed to approve reschedule request. Please try again.',
      request_reschedule_success: 'Lesson reschedule requested successfully',
      request_reschedule_error: 'Failed to request lesson reschedule. Please try again.',
    }
  },
  lesson_status: {
    'scheduled': 'Scheduled',
    'rescheduled': 'Rescheduled',
    'started': 'Started',
    'cancelled': 'Cancelled',
    'ongoing': 'Ongoing',
    'completed': 'Completed',
    'completed_absence': 'Completed (Absence)',
    'no_show': 'No Show',
  },
  my_items: {
    title: 'My Items',
    subtitle: 'These are the belonging items!',
    tabs: {
      food: 'Food',
      accessories: 'Accessories',
      pets: 'Pets',
    },
    feed_button: 'Feed',
    confirm_button: 'Confirm',
    take_off_button: 'Take off',
    change_pet_button: 'Change pet',
    go_to_shop_button: 'Go to shop',
    pet_reactions: {
      full: [
        "I'm stuffed! 😋",
        "I'm full now! 😌",
        "I've had enough, thank you! 🙏"
      ],
      after_eating: [
        "Yum, that {food_name} was tasty! 😋",
        "I love {food_name}! ❤️",
        "Thanks for the {food_name}! 😊",
        "{food_name}! Delicious! 😋",
      ],
      hungry: [
        "I'm so hungry! 😢",
        "Can I have some food, please? 🍽️",
        "My tummy is growling! 🥺",
        "Feed me, please! 🙏"
      ],
      accessory: [
        "This is perfect for me!",
        "I look amazing in this!",
        "I think I found my new look!",
        "This suits me so well!",
        "I’m rocking this accessory!",
        "I can’t believe how good this looks on me!",
        "I’m definitely owning this style!",
        "This is totally my vibe!",
        "Look at me, I’m fabulous!",
        "I feel so stylish with this!",
        "Oh wow, I look stunning!",
        "This was made for me!",
        "I feel extra fancy now!",
        "Now this is fashion!",
        "I’m looking sharp!",
        "Too cute to handle!",
        "I think this is my new favorite!",
        "I feel like a superstar!",
        "I was born to wear this!",
        "Dressing up is so much fun!"
      ]
    },
    no_content: {
      food: {
        title: "No food available",
        subtitle: "You haven't purchased anything yet."
      },
      accessories: {
        title: "No accessories available",
        subtitle: "You haven't purchased anything yet."
      },
      pets: {
        title: "No pets available",
        subtitle: "Go to shop to purchase pets."
      }
    }
  },
  shop: {
    title: "Shop",
    subtitle: "You can buy items for your pet here!",
    level_constraint: "Reach level {level} to unlock this item",
    no_content: {
      food: {
        title: "No food available",
        subtitle: "Check back later for more items."
      },
      accessories: {
        title: "No accessories available",
        subtitle: "Check back later for more items."
      },
      pets: {
        title: "No pets available",
        subtitle: "Check back later for more pets."
      },
      wallpapers: {
        title: "No wallpapers available",
        subtitle: "Check back later for more wallpapers."
      }
    },
    pet_name_prompt: "Give your pet a name!",
    pet_name: 'Pet Name',
    cancel_button: 'Cancel',
    confirm_button: 'Confirm',
    buy_pet_button: 'Buy Pet',
    buy_now_button: 'Buy Now',
    notify: {
      pet_name_required: "Please enter a pet name",
    },
  },
  misc: {
    handbook: 'Handbook',
  },
};
